// Utils
import {
    getNotificationReminderDueDate,
    getNotificationReminderHasDueDateTime,
    getNotificationRemindersAsArray,
    getNotificationTimestamp,
} from './notificationModelUtils';

import friendlyDateFormatter from '../utils/datetime/friendlyDateFormatter';
import simpleTimeFormatter from '../utils/datetime/simpleTimeFormatter';
import { getIsDueToday, getIsOverdue } from '../utils/timeUtil';
import { getDateAlignedToUserTimezone } from '../users/utils/userTimeUtils';

const getFormattedDueDateText = (reminder, dueDate, relativeTimestamp) => {
    const dueDateText = friendlyDateFormatter({
        timestamp: dueDate,
        simpleFormat: 'd mmm',
        longFormat: 'd mmm yyyy',
        relativeTimestamp,
    });

    return getNotificationReminderHasDueDateTime(reminder)
        ? `${dueDateText} (${simpleTimeFormatter(dueDate)})`
        : dueDateText;
};

export const getNotificationReminderDueDateTextAlignedToUsersTimezone = (reminder, user) => {
    const dueDate = getDateAlignedToUserTimezone(getNotificationReminderDueDate(reminder), user);
    const relativeTimestamp = getDateAlignedToUserTimezone(Date.now(), user);
    return getFormattedDueDateText(reminder, dueDate, relativeTimestamp);
};

export const getNotificationReminderDueDateText = (reminder) => {
    const dueDate = new Date(getNotificationReminderDueDate(reminder));
    return getFormattedDueDateText(reminder, dueDate);
};

export const getReminderDueDateClass = ({ reminder, notification }) => {
    const notificationTimestamp = getNotificationTimestamp(notification);
    const notificationDate = new Date(notificationTimestamp);

    const dueDate = new Date(getNotificationReminderDueDate(reminder));
    const hasDueDateTime = getNotificationReminderHasDueDateTime(reminder);

    if (getIsOverdue(dueDate, hasDueDateTime, notificationDate)) return 'overdue';

    if (getIsDueToday(dueDate, notificationDate)) return 'due-today';

    return 'due-future';
};

export const getIsDueSoon = ({ notification }) => {
    const reminders = getNotificationRemindersAsArray(notification);

    const notificationTimestamp = getNotificationTimestamp(notification);
    const notificationDate = new Date(notificationTimestamp);

    return reminders.some((reminder) => {
        const dueDate = new Date(getNotificationReminderDueDate(reminder));
        const hasDueDateTime = getNotificationReminderHasDueDateTime(reminder);

        return !getIsOverdue(dueDate, hasDueDateTime, notificationDate);
    });
};
